import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AdditionalFooterComponent } from './additional-footer.component';

import { TranslationLoaderService } from '@core-services/translation-loader.service';
import { locale as english } from '@core-layout/additional-footer/i18n/en';

@NgModule({
    imports: [
    CommonModule,
    TranslateModule,
    AdditionalFooterComponent
],
    exports: [AdditionalFooterComponent],
})
export class AdditionalFooterModule {
    constructor(private readonly translationLoaderService: TranslationLoaderService) {
        this.translationLoaderService.loadTranslations(english);
    }
}
